import { ReducerFunctions } from '../../utils';
import { OcrDocumentDelete, OcrDocuments } from './ocr';

export const ocr_documents_reducer = ReducerFunctions(OcrDocuments, {});
export const ocr_document_delete_reducer = ReducerFunctions(OcrDocumentDelete, {});